import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/layout/Hero';
import Introduction from '../../sections/LandingPage/Introduction';
import BuscaAbogado from '../../sections/LandingPage/BuscaAbogado';
import ConsultaExpress from '../../sections/LandingPage/ConsultaExpress';
import VisualRest from '../../sections/LandingPage/VisualRest';
import BlogSection from '../../sections/LandingPage/BlogSection';
import FaqSection from '../../sections/LandingPage/FaqSection';

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div>
      <Hero />
      <Introduction />
      <BuscaAbogado />
      <ConsultaExpress />
      <VisualRest />
      <BlogSection />
      <FaqSection />
    </div>
  );
}
